import React, { Component } from 'react';
import { Table, Alert } from 'react-bootstrap';
import DailySalesReportAPI from '../../../api/DailySalesReportAPI';
import { reactLocalStorage } from 'reactjs-localstorage';
import Constants from '../../../util/Constants';
import ChartComponent from '../FixedReportChart';
import ApiUiController from '../../../controller/ApiUiController';

class CallTalkTimeReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      totalTalkTime: 0,
      inApiCall: true,
    };
    this.users = reactLocalStorage.getObject(Constants.Model).user.options.filter((option)=>option.status === Constants.Active || option.status === Constants.AlwaysActive) || [];
  };
  componentDidMount() {
    this.fetchCallTalkTime();
  }

  // Fetch call data from API
  fetchCallTalkTime = () => {
    DailySalesReportAPI.getCallTalktime(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  };

  handleReceivedData = (response) => {
    if (Array.isArray(response)) {
      const totalTalkTime = response.reduce((sum, item) => sum + item.sum, 0);
      this.setState({ data: response, totalTalkTime , inApiCall: false});
    }
  };

  handleFail = (error) => {
    console.error('Error:', error);
    this.setState({ inApiCall: false });
  };

  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  getUserData = () => {
    const { data } = this.state;
    const mappedData = {};

    // Map talk time to user IDs for quick lookup
    data.forEach(({ responsible_person, sum }) => {
      mappedData[responsible_person] = sum;
    });

    return this.props.filters.selectedIds.map((id) => {
      const user = this.users.find((user) => user.value === parseInt(id));
      return {
        id,
        name: user?.name || 'Unknown',
        time: mappedData[id] || 0,
      };
    });
  };
  
  formatTimeForChart = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}.${remainingSeconds}`;
  };

  render() {
    const userData = this.getUserData();
    const user = this.props.filters.selectedIds.map((id) => {
      const user = this.users.find((user) => user.value === parseInt(id));
    return user} );
    const times = userData.reduce((acc, item) => {
      acc[item.id] = this.formatTimeForChart(item.time);
      return acc;
  }, {});
    return (
     <ApiUiController inApiCall={this.state.inApiCall}>
      <div className="call-talktime-report">
        <h4>Call Talktime Report</h4>
        <hr />
        <div className="row">
        <Table bordered hover striped className="col-md-5">
          <thead>
            <tr>
              <th>Sales Executive</th>
              <th>Total Talktime</th>
            </tr>
          </thead>
          <tbody>
            {userData.map((user) => (
              <tr key={user.id}>
                <td>{user.name}</td>
                <td>{this.formatTime(user.time)}</td>
              </tr>
            ))}
            <tr>
              <td><strong>Total</strong></td>
              <td><strong>{this.formatTime(this.state.totalTalkTime)}</strong></td>
            </tr>
          </tbody>
        </Table>
        <div className="col-md-5">
            {/* Add Chart Component */}
            <ChartComponent progressSums={times} progressOptions={user} type="bar" />
          </div>
        </div>
      </div>
      </ApiUiController>
    );
  }
}

export default CallTalkTimeReport;
